import { Router, NavigationEnd, ActivatedRoute, NavigationStart, NavigationError } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Injectable, signal } from '@angular/core';
import { BroadcastService } from '@fry-it/risr-core';
import { RouterHelperService } from '@fry/upgrade/router.helper.service';

@Injectable({
  providedIn: 'root'
})
export class RouterEventsService {
  private _remoteUser = signal<string | null>(null);
  remoteUser = this._remoteUser.asReadonly();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private broadcastService: BroadcastService,
    private routerHelper: RouterHelperService
  ) {
    // this.activatedRoute.params.subscribe({
    //   next: params => {
    //     const user = params.get('user');
    //     if (user) {
    //       this._remoteUser.set(user);
    //     } else {
    //       this._remoteUser.set(null);
    //     }
    //     this.broadcastService.broadcast('routerEvents:NavigationEnd');
    //   }
    // });

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
      console.log('NavigationStart')
      const currentUrl = this.router.url;
      const path = this.routerHelper.getPath();
      const ignoredPaths = [
        'events/new',
        'events/new/:user',
        'events/new-section/:eventTypeId',
        'events/new-section/:eventTypeId/:user',
        'events/fillin/:eventSectionId/:user',
        'events/fillin/:eventSectionId'
      ];
      if (path && !ignoredPaths.includes(path)) {
        this.routerHelper.setPreviousRoute(currentUrl);
      }
      this.broadcastService.broadcast('KZCurrentListChange', {});
      this.broadcastService.broadcast('routerEvents:NavigationStart');
    });

    // Subscribe to NavigationEnd events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // After navigation is complete, find the deepest activated route
      console.log('NavigationEnd')
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }

      // Now we can access the parameters of the current route
      const user = route.snapshot.paramMap.get('user');
      if (user) {
        this._remoteUser.set(user);
      } else {
        this._remoteUser.set(null);
      }

      this.broadcastService.broadcast('routerEvents:NavigationEnd');
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationError)
    ).subscribe(event => {
      console.log('NavigationError', event);
    });
  }
}